import { useQuery } from '@tanstack/react-query'

import { CompaniesClient } from '@shared/clients/http/CompaniesClient'

import { CurrentUserDTO } from '../types/Users/users'

type Props = {
  isEnabled: boolean
}

export function useGetCurrentUser(props: Props) {
  return useQuery<CurrentUserDTO>({
    enabled: props.isEnabled,
    queryKey: ['users:current:me'],
    queryFn: () => CompaniesClient.users().getCurrentUser(),
    refetchOnWindowFocus: false,
  })
}
